import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { FileSection, FileType, FileData } from './../models/fileData';
import { InvestorsService } from '../services/investors.service';
import { AppConfig } from './../config/app-config';
//import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'app-our-investors',
  templateUrl: './our-investors.component.html',
  styleUrls: ['./our-investors.component.css']
})
export class OurInvestorsComponent implements OnInit {

  constructor(
    private investorsService: InvestorsService,
    private appConfig: AppConfig) { }

  pageData = null;

  getPageData() {
    //this.pageData = this.investorsService.getDummyData();
    this.investorsService.getData().subscribe((response) => {
      this.pageData = response;
      console.log(response);
    }, (error) => {
    });
  }

  ngOnInit() {
  }

  //toggle(id) {

  //  $('#' + id + '_div').toggle();
  //}

  ngAfterContentInit() {
    try {
      this.getPageData();
    }
    catch (ex) {
      console.log(ex);
    }
  }

  getBackground(img: string) {
    //"url('./assets/images/our-investors/investors/{{inv.image}}')
    //return "url('./assets/images/our-investors/investors/" + img + "')";
    console.log(img);
    return img;
  }

  getImage(linkedId, img: string) {

    return "url('./assets/images/our-investors/investors/" + img + "')";

    //console.log("calling get image : " + linkedId +" - " + img)
    //this.investorsService.getImage(linkedId).subscribe((response) => {
    //  console.log("get images called")
    //  if (response.length > 0) {
    //    response.forEach((val, idx, arr) => {
    //      console.log(val)
    //      this.buildImageUrl(this.appConfig.baseUrl + '/Uploads/' + FileSection[val.fileSection] + '/' + FileType[val.fileType] + '/' + val.linkedId + '/' + val.physicalFileName);
    //    });
    //  }
    //  else {
    //    console.log("no db data");
    //    return "url('./assets/images/our-investors/investors/" + img + "')";
    //  }
    //}, (error) => {
    //  console.log(error);
    //});
  }

  buildImageUrl(fileLocation) {
    return "url('data:image/png;base64," + this.getBase64ImageFromURL(fileLocation) + "')";
    //this.getBase64ImageFromURL(fileLocation).subscribe((res) => {
    //  console.log("got b64");
    //  console.log(res);
    //  return "url('data:image/png;base64," + res.text() + "')";
    //});
  }

  getBase64ImageFromURL(url: string) {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          return this.getBase64Image(img);
          
        };
        
    }
    else
        return this.getBase64Image(img);
    //return Observable.create((observer: Observer<string>) => {
    //  const img = new Image();
    //  img.crossOrigin = 'Anonymous';
    //  img.src = url;
    //  if (!img.complete) {
    //    img.onload = () => {
    //      observer.next(this.getBase64Image(img));
    //      observer.complete();
    //    };
    //    img.onerror = (err) => {
    //      observer.error(err);
    //    };
    //  } else {
    //    observer.next(this.getBase64Image(img));
    //    observer.complete();
    //  }
    //});
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

}
